/* eslint-disable consistent-return */

const InflateComponents = require('utils/framework/InflateComponents');
// const Router = require('pages/Router/Router');
// const Page = require('Index/Page');

module.exports = (function() {

    const InflatorSPA = Sephora.Util.InflatorSPA = {};

    const inflateSpa = function() {
        var components, componentsByName = {};

        var componentsElement = document.body.querySelector('#linkSPA');
        if (componentsElement) {
            components = JSON.parse(componentsElement.innerHTML);
        }

        if (!components) {
            return InflatorSPA;
        }

        for (var id in components) {
            if (components.hasOwnProperty(id)) {
                components[id].element = document.body.querySelector('[rootid="' + id + '"]');
            }
        }

        // require.ensure is used to package nested requires in components.chunk.js
        // rather than priority.bundle.js in order to keep priority.bundle.js lean
        require.ensure([], function (require) {
            let MainComponent = require('pages/' + Sephora.renderedData.template);
            const GlobalContent = require('components/GlobalContent/GlobalContent');

            // This IF statement will be deleted/replaced with generic code when spa-brand-nth-category branch is merged to dev
            if (Sephora.renderedData.template === require('../../constants/PageTemplateType').ProductPage) {
                const React = require('react');
                const { Fragment } = require('react');
                const LoadSpaPageProgressBar = require('../../components/LoadSpaPageProgressBar/LoadSpaPageProgressBar');
                const withLoadSpaPageProgress = require('../../hocs/page/withLoadSpaPageProgress.connect');
                const ConnectedLoadSpaPageProgressBar = withLoadSpaPageProgress(LoadSpaPageProgressBar);
                const SpaPage = MainComponent;
                MainComponent = props => (
                    <Fragment>
                        <ConnectedLoadSpaPageProgressBar />
                        <SpaPage {...props} />
                    </Fragment>
                );
                MainComponent.prototype.class = SpaPage.prototype.class;
            }

            if (components['Header']) {
                const Header = require('components/Header/Header');
                InflateComponents.render(Header, components['Header'].props, document.body.querySelector('[rootid="Header"]'), true);
            }
            let mainComponentElement = document.body.querySelector('[rootid="'+MainComponent.prototype.class+'"]');
            if (MainComponent.prototype.renderOnLoadEvent) {
                InflateComponents.queue(MainComponent,
                    components[MainComponent.prototype.class].props,
                    MainComponent.prototype.renderOnLoadEvent,
                    mainComponentElement);
            } else {
                InflateComponents.render(MainComponent,
                    components[MainComponent.prototype.class].props,
                    mainComponentElement,
                    true);
            }
            InflateComponents.render(GlobalContent, components[GlobalContent.prototype.class].props, document.body.querySelector('[rootid="'+GlobalContent.prototype.class+'"]'), true);
            // InflateComponents.render(Router, components[Router.prototype.class].props, document.body.querySelector('[rootid="'+Router.prototype.class+'"]'), true);

            Sephora.Util.InflatorComps.hydrationFinished = true;
            window.dispatchEvent(new CustomEvent('hydrationFinished'));
        }, 'components');
    };

    // make sure DOM is ready
    if (!Sephora.DOMContentLoadedFired) {
        window.addEventListener('DOMContentLoaded', function () {
            inflateSpa();
        });
    } else {
        inflateSpa();
    }
})();
